import { MerkleTransactionCostDisplay } from '~/components/txn-display/cost-display/MerkleTransactionCostDisplay'
import { RegularTransactionCostDisplay } from '~/components/txn-display/cost-display/RegularTransactionCostDisplay'
import { BackendTransaction } from '~/types'

export const TransactionCostDisplay = ({
  transaction,
}: {
  transaction: BackendTransaction
}) => {
  switch (transaction.isMerkleTransaction) {
    case true:
      return <MerkleTransactionCostDisplay transaction={transaction} />
    default:
      return <RegularTransactionCostDisplay transaction={transaction} />
  }
}
